module.exports = __webpack_public_path__ + "static/img/8.41f10b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/8.png
// module id = zWDf
// module chunks = 0